import React from "react"
import { Wrapper, RichTextAreaContainer } from "./styles"
import { renderHTML } from "../../agility/utils"

const RichTextArea = ({ item }) => {
  return (
    <RichTextAreaContainer>
      <Wrapper>
        <div dangerouslySetInnerHTML={renderHTML(item.customFields.textblob)} />
      </Wrapper>
    </RichTextAreaContainer>
  )
}

export default RichTextArea
